import { ReactElement } from 'react';

import { ChatContentContainer } from '../../../components/layout/chatContentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { ReloadSuggestionContainer } from '../../../components/reloadSuggestion/reloadSuggestionContainer';
import { ReloadSuggestionHeader } from '../../../components/reloadSuggestion/reloadSuggestionHeader';

const ReloadSuggestion = (): ReactElement => {
	return (
		<>
			<HeaderContainer>
				<ReloadSuggestionHeader />
			</HeaderContainer>
			<ChatContentContainer>
				<ReloadSuggestionContainer />
			</ChatContentContainer>
		</>
	);
};

export { ReloadSuggestion };
